module.exports = __webpack_public_path__ + "img/energy-price-alerts-md.e66e9b85.png";